import { useBackend } from '@/hooks/useBackend';
import { useEventFilterParams } from '@/hooks/useEventFilterParams';
import { FacetFilter } from '@/pages/explorer/filters/FacetFilter';

export function EventFilter() {
  const filterParams = useEventFilterParams();

  const { data: eventFacets } = useBackend(
    '/events/facets',
    { params: { query: filterParams } },
    { keepPreviousData: true },
  );

  if (!eventFacets) return null;

  return (
    <div className="flex flex-col gap-2">
      <FacetFilter filterKey="stage" label="Stage" values={eventFacets.stage} />
      <FacetFilter filterKey="classification" label="Classification" values={eventFacets.classification} />
      <FacetFilter filterKey="serviceDomainId" label="Service Domain" values={eventFacets.serviceDomainId} />
    </div>
  );
}
